import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import {Signals} from "@/Imports";
import TweenMax from "gsap";
import GameStatesEnum from "@/states/GameStatesEnum";
import Config from "@/config/Config";
import Facade from "@/Facade";

export default class CurtainContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init()
  }

  init(data) {
    Signals.makeBets.add(this.reset, this)
    //Signals.stateChanged.add(this.onStateChanged, this)
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.roundStart.add(this.onRoundStart, this)

    this.black = new PIXI.Graphics()
    this.addChild(this.black)
    this.visible = true
    //this.alpha = 1
    this.onOrientationChanged(Facade.orientation)
  }

  reset() {
    TweenMax.killTweensOf(this.black)
    TweenMax.to(this.black, 0.6, {alpha: 0})
  }

  onStateChanged(state) {
    switch (state) {
      case GameStatesEnum.IDLE:
        this.reset()
        break
    }
  }

  onRoundEnd() {
    this.visible = true
    TweenMax.to(this.black, 1, {alpha: 0.9, delay: 1.8})
  }

  onRoundStart() {
    TweenMax.to(this.black, 0.6, {alpha: 0})
  }

  onOrientationChanged(orientationSymbol) {
    if(this.black) {
      this.black.clear()
    }
    this.black.beginFill(0x000000, 1)
    this.black.drawRoundedRect(0, 0, Config.currentPattern.mainMask.width, Config.currentPattern.mainMask.height + 300, 15)
  }


}
